



















































































import Vue from 'vue';
import store from '@/store';
import { BaseOrganization, WebRequestStatus } from '@/models';
import { sleep } from '@/utils';
import OrganizationLoadGuard from '@/components/OrganizationLoadGuard.vue';
import WidthLimitedMd from '@/components/utils/WidthLimitedMd.vue';

export default Vue.extend({
  components: {
    OrganizationLoadGuard,
    WidthLimitedMd
  },

  props: {
    organizationId: {
      type: Number,
      required: true
    }
  },

  computed: {
    organization(): BaseOrganization {
      return store.state.org.basic;
    },

    adminAccess(): boolean {
      return store.state.org.adminAccess;
    },

    registrationStatus(): WebRequestStatus {
      return store.getters.org.status.ltiRegistration();
    },

    inProgress(): boolean {
      return this.registrationStatus === WebRequestStatus.IN_PROGRESS;
    },

    isSuccess(): boolean {
      return this.registrationStatus === WebRequestStatus.SUCCESS;
    },

    isFailure(): boolean {
      return this.registrationStatus === WebRequestStatus.FAILURE;
    },

    isRegistered(): boolean {
      return this.isSuccess || !!this.organization.ltiPending;
    },

    openidConfiguration(): string | null {
      return (this.$route.query.openid_configuration as string) || null;
    },

    registrationToken(): string | null {
      return (this.$route.query.registration_token as string) || null;
    },

    validationError(): string | null {
      if (!this.adminAccess) {
        return 'You must be an administrator of this organization to complete the LTI registration.';
      }
      if (!this.openidConfiguration || !this.registrationToken) {
        return 'Missing required LTI registration parameters (openid_configuration or registration_token). Please restart the registration from your LMS.';
      }
      return null;
    }
  },

  methods: {
    async register() {
      if (!this.openidConfiguration || !this.registrationToken) {
        return;
      }

      store.dispatch.org.registerLti({
        openidConfiguration: this.openidConfiguration,
        registrationToken: this.registrationToken
      });
    },

    closeWindow() {
      window.close();
      // Fallback for browsers that block window.close()
      this.$router.push({
        name: 'Organization',
        params: { organizationId: `${this.organizationId}` }
      });
    }
  },

  watch: {
    async registrationStatus(status: WebRequestStatus) {
      if (status === WebRequestStatus.SUCCESS) {
        await sleep(2000);
        this.closeWindow();
      }
    }
  }
});
